<template>
  <div class="bg-card wow fadeInDown">
    <div class="zy-container">
      <div class="card">
        <div class="card-col">
          <div class="card-head">
            <div class="card-title">
              {{ funcData.title }}
            </div>
            <div class="card-func-sub-title">
              {{ funcData.subTitle }}
            </div>
            <div class="card-desc">
              {{ funcData.desc }}
            </div>
            <div class="func-bar">
              <template v-if="mode===1">
                <el-image :src="funcData.imgUrl" class="img-icon"/>
              </template>
              <template v-if="mode===2">
                <div class="func-mode">
                  <div class="fun-item" v-for="(item,index) in funcData.funcInfo.leftFunc" :key="index">
                    <div class="fun-title">
                      {{ item.title }}
                    </div>
                    <div class="fun-dec">
                      {{ item.subDesc }}
                    </div>
                  </div>
                </div>
                <el-image :src="funcData.imgUrl" class="click-image"/>
                <div class="func-mode">
                  <div class="fun-item" v-for="(item,index) in funcData.funcInfo.rightFunc" :key="index">
                    <div class="fun-title">
                      {{ item.title }}
                    </div>
                    <div class="fun-dec">
                      {{ item.subDesc }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {WOW} from "wowjs";

export default {
  props: {
    funcData: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: Number,
      default: () => 1
    }
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  },
  data() {
    return {}
  },
  methods: {
    openHandler() {
      this.$router.push("/login");
    }
  }
}
</script>

<style scoped lang="scss">
.bg-card {
  background: #F8F8FC;
  padding-bottom: 2px;
}

.func-title {
  font-size: 36px;
  font-weight: 500;
  color: #333333;
  padding-bottom: 100px;
}

.card {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .card-col {
    padding-top: 43px;
    padding-bottom: 43px;
    width: 100%;
    margin-bottom: 2%;
    background: #FFFFFF;
    border-radius: 30px;
    box-shadow: 0px 0 52px 0px rgba(225, 225, 246, 0.45);
  }

}


.card-head {
  width: 70%;
  margin: 0 auto;

  .card-title {
    font-size: 29px;
    font-weight: 600;
    color: #333333;
    text-align: center;
    position: relative;
  }

  .card-func-sub-title {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    text-align: center;
    padding-bottom: 27px;
    line-height: 33px;
  }

  .card-desc {
    margin: 0 auto;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    text-align: center;
    padding-bottom: 10px;
  }

  .click-image {
    margin-left: 21px;
    margin-right: 21px;
  }

  .func-bar {
    display: flex;

    .func-mode {
      padding-top: 40px;
    }

    .fun-item:not(:first-child) {
      padding-top: 49px;
    }

    .fun-title {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
    }

    .fun-dec {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
  }

}

.flex {
  display: flex;
  justify-content: center;
}


.img-icon {
  width: 590px;
  display: block;
  margin: 0 auto;
}


</style>
